import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Home, ArrowLeft, Compass } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-background relative overflow-hidden" data-testid="not-found">
      <div className="aurora" />
      <div className="relative text-center px-6 max-w-lg">
        <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-cyan-400 border border-cyan-500/40 rounded-full px-3 py-1">
          <Sparkles className="w-3 h-3" /> 404 · Lost in the algorithm
        </div>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
          This page didn't <span className="bg-gradient-to-r from-cyan-300 via-cyan-400 to-pink-400 bg-clip-text text-transparent">go viral</span>.
        </h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          The link you followed may be broken, or the page may have moved.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="rounded-full bg-gradient-to-r from-cyan-400 to-pink-500 text-zinc-950 border-0 hover:brightness-110" data-testid="not-found-home">
            <Link to="/"><Home className="w-4 h-4 mr-2" /> Return home</Link>
          </Button>
          <Button asChild variant="ghost" className="rounded-full" data-testid="not-found-features">
            <Link to="/features"><Compass className="w-4 h-4 mr-2" /> Explore features</Link>
          </Button>
        </div>
        <button
          onClick={() => window.history.back()}
          className="mt-6 text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2"
          data-testid="not-found-back"
        >
          <ArrowLeft className="w-4 h-4" /> Go back
        </button>
      </div>
    </div>
  );
}
